<app-spinner-utileria *ngIf='spinner'></app-spinner-utileria>
<div class="row" style="width: 100%;" *ngIf="configured">
    <div class="flex flex-col flex-auto min-w-0">
        <div class="flex-auto border-t -mt-px pt-4 sm:pt-6">
            <div class="w-full max-w-screen-xl mx-auto">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
                    <div
                        class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                        <!-- formulario -->
                        <div class="flex flex-col sm:flex-row items-start justify-between">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div *ngIf="!banderaActualizarFactura"
                                        class="text-lg font-medium tracking-tight leading-6 truncate titulo">
                                        &equiv; Nuevo CFDI 4.0</div>

                                    <div *ngIf="banderaActualizarFactura && banderaEstatusFactura == null"
                                        class="text-lg font-medium tracking-tight leading-6 truncate titulo">
                                        &equiv; Actualizar CFDI 4.0</div>

                                    <div *ngIf="banderaActualizarFactura && banderaEstatusFactura == 2"
                                        class="text-lg font-medium tracking-tight leading-6 truncate titulo">
                                        &equiv; Duplicar CFDI 4.0</div>
                                </div>
                                <div class="col-sm-12">
                                    <p>
                                        <small>
                                            Por favor ingrese los siguientes datos para la creación de su
                                            factura.
                                            <br>
                                            Los campos marcados con <span class="required">*</span> son
                                            obligatorios.
                                        </small>
                                        <br><br>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="flex flex-col sm:flex-row items-start justify-between"> -->
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="alert alert-warning" role="alert"
                                    *ngIf="banderaActualizarFactura && banderaEstatusFactura === 2">
                                    Estas duplicando esta factura, para continuar realiza las modificaciones que
                                    necesites y finaliza con la opción Duplicar Factura, de lo contrario presiona el
                                    botón <mat-icon svgIcon="mat_outline:cancel"></mat-icon> "Cerrar sin guardar"
                                </div>
                            </div>
                        </div>
                        <!-- </div> -->
                        <form class="flex-col p-3" [formGroup]="facturaForm">
                            <div class="row justify-content-start align-items-center">
                                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">

                                    <!-- <mat-form-field appearance="fill">
                                        <mat-label>Tipo de factura</mat-label>
                                        <mat-select formControlName="tipoFactura" [disabled]="banderaActualizarFactura"
                                            (selectionChange)="changeTipoFactura($event.value)">
                                            <mat-option [value]="0">
                                                Seleccione un tipo de factura
                                            </mat-option>
                                            <mat-option *ngFor="let factura of lstTipoFactura" [value]="factura.id">
                                                {{factura.attributes.nombre}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field> -->
                                    <ng-container *ngIf="!banderaActualizarFactura; else disabledSelect">
                                        <mat-form-field appearance="fill">
                                          <mat-label>Tipo de factura</mat-label>
                                          <mat-select formControlName="tipoFactura" (selectionChange)="changeTipoFactura($event.value)">
                                            <mat-option [value]="0">Seleccione un tipo de factura</mat-option>
                                            <mat-option *ngFor="let factura of lstTipoFactura" [value]="factura.id">
                                              {{ factura.attributes.nombre }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </ng-container>
                                      
                                      <ng-template #disabledSelect>
                                        <mat-form-field appearance="fill">
                                          <mat-label>Tipo de factura</mat-label>
                                          <mat-select formControlName="tipoFactura" disabled>
                                            <mat-option [value]="0">Seleccione un tipo de factura</mat-option>
                                            <mat-option *ngFor="let factura of lstTipoFactura" [value]="factura.id">
                                              {{ factura.attributes.nombre }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </ng-template>

                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6"></div>
                            </div>
                            <span *ngIf="seleccionTipoFactura">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Nombre Emisor</mat-label>
                                            <mat-select formControlName="emisorRSocial"
                                                (selectionChange)="changeEmisor($event.value)">
                                                <mat-option [value]="0">
                                                    Seleccione un emisor
                                                </mat-option>
                                                <mat-option *ngFor="let emisor of emisorRSocial" [value]="emisor.id">
                                                    {{emisor.attributes.razonSocial}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div [hidden]="clienteRule?.hidden"
                                    class="row justify-content-start align-items-center">
                                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <mat-form-field appearance="fill" *ngIf="!cliente">
                                            <mat-label>Cliente</mat-label>
                                            <mat-icon matPrefix>search</mat-icon> <!-- Ícono de búsqueda -->
                                            <input type="text" matInput placeholder="Buscar cliente..."
                                                [formControl]="clienteControl" [matAutocomplete]="auto"
                                                (input)="filterClientes($event.target.value)" />
                                            <mat-autocomplete #auto="matAutocomplete"
                                                (optionSelected)="curCliente($event.option.value)">
                                                <mat-option *ngFor="let cliente of filteredClientes"
                                                    [value]="cliente.id">
                                                    ({{ cliente.attributes.rfc }}) {{ cliente.attributes.nombre }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>


                                        <div class="form-group mb-3" *ngIf="cliente">
                                            <label for="simulatedInput" style="font-size: 12px;">Cliente</label>
                                            <div style="padding: 10px 0.75rem;"
                                                class="form-control d-flex justify-content-between align-items-center mt-1"
                                                id="simulatedInput">
                                                <span style="font-size: 14px;">({{ cliente.attributes.rfc }}) {{
                                                    cliente.attributes.nombre }}</span>
                                                <button type="button" class="btn btn-sm btn-light border-0"
                                                    aria-label="Clear" (click)="clearCliente()">
                                                    &times;
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-sm-2">
                                        <button class="mt-6" (click)="openDialogNewCliente(1)" mat-flat-button
                                            color="primary">Nuevo Cliente</button>
                                    </div> -->
                                    <div class="col-sm-2">
                                        <button class="mt-6" (click)="agregarClienteSimplificado()" mat-flat-button
                                            color="primary">Nuevo Cliente</button>
                                    </div>
                                    <!--<div class="col-sm-2">
                                        <button class="mt-6" (click)="openDialogNewCliente(2)" mat-flat-button
                                            color="primary" *ngIf="cliente">Editar
                                            Cliente</button>
                                    </div>-->
                                    <div class="col-sm-2">
                                        <button class="mt-6" (click)="modificarCliente()" mat-flat-button
                                            color="primary" *ngIf="cliente">Editar
                                            Cliente</button>
                                    </div>
                                </div>
                                <div class="row justify-content-start align-items-center">
                                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6"
                                        [hidden]="lugarExpedicionRule?.hidden">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Lugar de expedición</mat-label>
                                            <mat-select formControlName="lugarExpedicion"
                                                [disabled]="lugarExpedicionRule?.disabled"
                                                (selectionChange)="PostSelSerie($event.value, 1)">
                                                <mat-option *ngFor="let lugarExpedicion of ltsLugarExpedicion"
                                                    [value]="lugarExpedicion.id">
                                                    ({{lugarExpedicion.attributes.dir_direccion.data.attributes.codigoPostal}}){{lugarExpedicion.attributes.nombre}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                    </div>
                                    <div class="col-sm-6">
                                        <mat-label>Código Postal Emisor</mat-label>
                                        <mat-form-field appearance="fill">
                                            <input matInput placeholder="Código Postal Emisor"
                                                formControlName="emisorCP"
                                                oninput="this.value = this.value.toUpperCase()"
                                                onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))"
                                                [maxlength]="emisorCPRule?.maxLength" [readonly]="true">
                                        </mat-form-field>
                                    </div>
                                    <ng-container *ngIf="serieFlag">
                                        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6"
                                            [hidden]="lugarExpedicionRule?.hidden">
                                            <mat-form-field appearance="fill">
                                                <mat-label>Serie</mat-label>
                                                <ng-container *ngIf="spinnerSerie">
                                                    <div class="lds-ellipsis">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                </ng-container>
                                                <mat-select formControlName="serie"
                                                    [disabled]="lugarExpedicionRule?.disabled || spinnerSerie"
                                                    (selectionChange)="changeSerie($event.value)">
                                                    <mat-option *ngFor="let serie of ltsSerie" [value]="serie.id">
                                                        {{serie.attributes.nombre}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </ng-container>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6" [hidden]="formaPagoRule?.hidden">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Forma de pago</mat-label>
                                            <mat-select formControlName="formaPago"
                                                (selectionChange)="curFormaPago($event.value)"
                                                [disabled]="formaPagoRule?.disabled">
                                                <mat-option *ngFor="let formPago of ltsFormaPago" [value]="formPago.id">
                                                    {{formPago.attributes.clave}} - {{formPago.attributes.descripcion}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6"
                                        [hidden]="metodoPagoRule?.hidden">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Método de pago</mat-label>
                                            <mat-select formControlName="metodoPago"
                                                (selectionChange)="curMetodoPago($event.value)"
                                                [disabled]="metodoPagoRule?.disabled">
                                                <mat-option *ngFor="let metodoPago of ltsMetodoPagoAux"
                                                    [value]="metodoPago.id" [disabled]="metodoPago.active">
                                                    {{metodoPago.clave}} - {{metodoPago.nombre}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        &nbsp;
                                    </div>

                                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <button mat-button type="button" style="background-color:none;"
                                            (click)="DatosAdicionales()">
                                            <span style="color:blue;">&triangledown; Ver opciones
                                                adicionales</span>
                                        </button>
                                    </div>
                                </div>

                            </span>

                        </form>

                        <form [formGroup]="facturaAdicionalesForm" *ngIf="datosAdicionales" class="flex-col p-3">
                            <div class="row justify-content-start align-items-center">
                                <div class="col-sm-12 col-md-6 col-xl-6 " [hidden]="numeroPedidoRule?.hidden">
                                    <mat-label>Número de pedido</mat-label>
                                    <mat-form-field appearance="fill">
                                        <input matInput placeholder="Número de pedido" formControlName="numeroPedido"
                                            oninput="this.value = this.value.toUpperCase()"
                                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                                            [readonly]="numeroPedidoRule?.disabled">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 " [hidden]="monedaRule?.hidden">
                                    <mat-label>Moneda</mat-label>
                                    <mat-form-field appearance="fill">
                                        <input type="text" placeholder="MXN - Peso Mexicano" aria-label="Number"
                                            matInput formControlName="moneda" [disabled]="monedaRule?.disabled"
                                            [matAutocomplete]="autoMoneda">
                                        <mat-autocomplete autoActiveFirstOption #autoMoneda="matAutocomplete"
                                            [displayWith]="displayFnMoneda"
                                            (optionSelected)="changeMoneda($event.option.value.id)">
                                            <mat-option *ngFor="let moneda of filteredMonedas | async" [value]="moneda">
                                                {{moneda.attributes.clave}}-{{ moneda.attributes.descripcion}}
                                            </mat-option>
                                        </mat-autocomplete>
                                        <!-- <mat-select placeholder="MXN - Peso Mexicano" [disabled]="monedaRule?.disabled"
                                            formControlName="moneda" (selectionChange)="changeMoneda($event.value)">
                                            <mat-option *ngFor="let moneda of ltsMoneda" [value]="moneda.id">
                                                {{moneda.attributes.clave}}-{{ moneda.attributes.descripcion}}
                                            </mat-option>
                                        </mat-select> -->
                                    </mat-form-field>
                                    <!-- {{this.facturaAdicionalesForm.value | json}} -->
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 " [hidden]="tipoCambioRule?.hidden">
                                    <mat-label>Tipo de cambio </mat-label>
                                    <mat-form-field appearance="fill">
                                        <input matInput placeholder="Tipo de cambio respecto al peso"
                                            formControlName="tipoCambio" appTwoDigitDecimaNumber
                                            [readonly]="tipoCambioRule?.disabled">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6" [hidden]="fechaEmisionRule?.hidden">
                                    <mat-label class="inline">Fecha de Emisión</mat-label>
                                    <mat-form-field appearance="fill">
                                        <mat-select placeholder="Selecciona" formControlName="fechaEmision"
                                            [disabled]="fechaEmisionRule?.disabled">
                                            <mat-option *ngFor="let fechEmi of fechaEmisionValor" [value]="fechEmi.id">
                                                {{ fechEmi.attributes.nombre }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 " [hidden]="numeroCuentaRule?.hidden">
                                    <mat-label>Número de cuenta</mat-label>
                                    <mat-form-field appearance="fill">
                                        <input matInput placeholder="Número de cuenta de pago"
                                            formControlName="numerodeCuenta"
                                            oninput="this.value = this.value.toUpperCase()" maxlength="4"
                                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))"
                                            [readonly]="numeroCuentaRule?.disabled">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 " [hidden]="nombreBancoRule?.hidden">
                                    <mat-label>Nombre del Banco</mat-label>
                                    <mat-form-field appearance="fill">
                                        <input matInput placeholder="Nombre del Banco"
                                            [readonly]="nombreBancoRule?.disabled" formControlName="nombreBanco"
                                            oninput="this.value = this.value.toUpperCase()" maxlength="20" onkeypress="return (
                                                            (event.charCode >= 48 && event.charCode <= 57)
                                                            || (event.charCode >= 65 && event.charCode <= 90)
                                                            || (event.charCode >= 97 && event.charCode <= 122)
                                                            || event.charCode == 35
                                                            || event.charCode == 36
                                                            || event.charCode == 37
                                                            || event.charCode == 38
                                                            || event.charCode == 47
                                                            || event.charCode == 40
                                                            || event.charCode == 41
                                                            || event.charCode == 60
                                                            || event.charCode == 61
                                                            || event.charCode == 34
                                                            || event.charCode == 35
                                                            || event.charCode == 161
                                                        )">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 " [hidden]="condicionesPagoRule?.hidden">
                                    <mat-label>Condiciones de pago</mat-label>
                                    <mat-form-field appearance="fill">
                                        <input matInput placeholder="Condiciones de pago"
                                            formControlName="condicionesPago"
                                            oninput="this.value = this.value.toUpperCase()" onkeypress="return (
                                                            (event.charCode >= 48 && event.charCode <= 57)
                                                            || (event.charCode >= 65 && event.charCode <= 90)
                                                            || (event.charCode >= 97 && event.charCode <= 122)
                                                        )" [maxlength]="condicionesPagoRule?.maxLength"
                                            [readonly]="condicionesPagoRule?.disabled">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 " [hidden]="seleccionaObservacionRule?.hidden">
                                    <mat-label>Observaciones</mat-label>
                                    <mat-form-field appearance="fill">
                                        <mat-select placeholder="Selecciona"
                                            [disabled]="seleccionaObservacionRule?.disabled"
                                            (selectionChange)="changeDescripcion($event.value)"
                                            formControlName="seleccionaObservacion">
                                            <!-- <mat-option [value]=0>
                                                Sin observacion
                                            </mat-option>
                                            <mat-option [value]=1>
                                                Con observacion
                                            </mat-option> -->
                                            <mat-option [value]=1>
                                                Observación manual
                                            </mat-option>
                                            <mat-option *ngFor="let observacion of lstObservaciones"
                                                [value]="observacion.id">
                                                {{ observacion.attributes.nombre }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-hint>{{ lstObservaciones?.length == 0 ? 'No hay un catálogo de
                                            observaciones disponibles.' : '' }}</mat-hint>
                                    </mat-form-field>

                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 " [hidden]="seleccioneCuentaBancoRule?.hidden">
                                    <mat-label>Cuenta de Banco</mat-label>
                                    <mat-form-field appearance="fill">
                                        <mat-select formControlName="seleccioneCuentaBanco"
                                            [disabled]="seleccioneCuentaBancoRule?.disabled">
                                            <mat-option *ngFor="let cuentaBanco of lstCuentaBancaria"
                                                [value]="cuentaBanco.id">
                                                <ng-template
                                                    [ngIf]="cuentaBanco?.attributes?.cat_banco?.data?.attributes?.nombre"
                                                    [ngIfElse]="loadingCat">
                                                    {{ cuentaBanco.attributes.noCuenta }} - {{
                                                    cuentaBanco?.attributes?.cat_banco?.data?.attributes?.nombre }}
                                                </ng-template>
                                                <ng-template #loadingCat>
                                                    {{ cuentaBanco.attributes.noCuenta }}
                                                </ng-template>

                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 ">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Exportación<mat-icon class="mat-18"
                                                matTooltip="CFDI 4.0- Atributo requerido para expresar si el comprobante ampara una operación de exportación.">info</mat-icon></mat-label>
                                        <mat-select formControlName="seleccioneExportacion"
                                            matTooltip="CFDI 4.0- Atributo requerido para expresar si el comprobante ampara una operación de exportación.">
                                            <mat-option *ngFor="let exportacion of lstExportacion"
                                                [value]="exportacion.id">
                                                {{ exportacion.attributes.clave }} - {{ exportacion.attributes.nombre }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6 ">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Confirmación<mat-icon class="mat-18"
                                                matTooltip="CFDI 4.0- Atributo condicional para registrar la clave de confirmación que entregue el PAC para expedir el comprobante con importes grandes, con un tipo de cambio fuera del rango establecido o con ambos casos.">info</mat-icon></mat-label>
                                        <input matInput placeholder="Clave de confirmación"
                                            formControlName="confirmacion"
                                            matTooltip="CFDI 4.0- Atributo condicional para registrar la clave de confirmación que entregue el PAC para expedir el comprobante con importes grandes, con un tipo de cambio fuera del rango establecido o con ambos casos."
                                            oninput="this.value = this.value.toUpperCase()">
                                    </mat-form-field>
                                </div>

                                <div *ngIf="desObservacion" class="col-sm-12 col-md-12 col-xl-12 ">
                                    <mat-label>Observaciones</mat-label>
                                    <mat-form-field appearance="fill">
                                        <input matInput placeholder="Observación" formControlName="observaciones"
                                            oninput="this.value = this.value.toUpperCase()"
                                            (focusout)="onFocusOutObservaciones()">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6"></div>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-xl-12">
                                            <mat-label>CFDI Relacionados</mat-label>
                                            <mat-form-field appearance="fill">
                                                <mat-select placeholder="Seleccione una opción"
                                                    formControlName="cFDIRelacionado"
                                                    (selectionChange)="seleccionarRelacionados($event.value, 1)">
                                                    <mat-option [value]=0>
                                                        Seleccione una opción
                                                    </mat-option>
                                                    <mat-option *ngFor="let relacionados of lstCfdiRelacionados"
                                                        [value]="relacionados.id">
                                                        ({{ relacionados.attributes.clave }}) {{
                                                        relacionados.attributes.descripcion }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-12 col-md-12 col-xl-12"
                                            *ngIf="this.facturaAdicionalesForm.controls.cFDIRelacionado.value >= 1">
                                            <button mat-raised-button color="primary" title="Buscar CFDI Relacionado"
                                                (click)="btnCfdiRelacionados(this.facturaAdicionalesForm.controls.cFDIRelacionado.value, 1)">
                                                <i class="material-icons" style="color: white">note_add</i> Agregar
                                                desde lista
                                            </button>
                                        </div>

                                        <div class="col-sm-12 col-md-12 col-xl-12 " *ngIf="showCfdiManual"
                                            style="margin-bottom: 30px;">
                                            <mat-label>Relacionar folio manual</mat-label>
                                            <mat-form-field>
                                                <input matInput style="font-size: 12px" placeholder="Folio fiscal"
                                                    formControlName="folioManual" (change)="changeRelacionados($event)"
                                                    pattern="^[a-f0-9A-F]{8}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12}$">
                                                <button mat-flat-button title="Folio Manual"
                                                    (click)="agregarFolioManual()">
                                                    <i class="material-icons" style="color: #2196F3">add</i>
                                                </button>
                                                <mat-hint>Ingrese su folio fiscal y da click en (+) para
                                                    agregar</mat-hint>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-12 col-md-12 col-xl-12 relacionados"
                                            *ngIf="contenedorCfdiRelacionados.length > 0">
                                            <mat-label>Folios fiscales relacionados</mat-label>
                                            <mat-list>
                                                <mat-list-item
                                                    *ngFor="let c of contenedorCfdiRelacionados; let index = index">
                                                    <div class="list-item-content">
                                                        <span class="folio-text">{{ c.cfdiRelacionados }}</span>
                                                        <button mat-icon-button color="warn"
                                                            (click)="eliminarRelacionado(index)" aria-label="Eliminar">
                                                            <mat-icon>delete</mat-icon>
                                                        </button>
                                                    </div>
                                                </mat-list-item>
                                            </mat-list>
                                        </div>

                                        <div class="col-sm-12 col-md-12 col-xl-12"
                                            *ngIf="showCfdiManual && contenedorCfdiRelacionados.length == 0">
                                            <span class="no-relacionados">No hay folios relacionados agregados</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>

                    <app-nuevo-cliente *ngIf="mostrarComponenteCliente"
                        (cerrarNuevoCliente)="invocarEventoCliente($event)"
                        [edicionDatosCliente]="arregloClienteSeleccionado">
                    </app-nuevo-cliente>

                    <!-- Carta porte -->
                    <div *ngIf="seleccionTipoFactura && idTipoFactura === 4"
                        class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto overflow-hidden">
                        <div class="row">
                            <div class="col-sm-12">
                                <mat-card>
                                    <app-factura-cporte *ngIf="formComplementoporte" [tipo]="1"
                                        [idOperacion]="idEmpresa" [idFacturaEdit]="FacturaEdit"
                                        [detalleFactura]="formeviando"></app-factura-cporte>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                    <!-- ********     Factura Global  ********  -->
                    <div *ngIf="seleccionTipoFactura && idTipoFactura === 5"
                        class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto overflow-hidden">
                        <form class="flex-col p-3" [formGroup]="facturaGlobalForm">
                            <div class="row">
                                <!-- <div class="col-sm-12"> -->
                                <mat-card>
                                    <h5 class="mt-5">Información Global</h5>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4 col-xl-4">
                                            <mat-label>Periodicidad</mat-label>
                                            <mat-form-field appearance="fill">
                                                <mat-select placeholder="Seleccione una opcion"
                                                    formControlName="periodicidad"
                                                    (selectionChange)="seleccionarPeriodicidad($event.value)">
                                                    <mat-option [value]=0>
                                                        Seleccione una opción
                                                    </mat-option>
                                                    <mat-option *ngFor="let periodicidad of periodicidadFactGlobal"
                                                        [value]="periodicidad.id">
                                                        {{periodicidad.attributes.clave}}-{{periodicidad.attributes.periodicidad}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-xl-4">
                                            <mat-label>Mes</mat-label>
                                            <mat-form-field appearance="fill">
                                                <mat-select placeholder="Seleccione una opcion"
                                                    formControlName="mesFactGlobal">
                                                    <mat-option [value]=0>
                                                        Seleccione una opción
                                                    </mat-option>
                                                    <mat-option *ngFor="let mesFact of mesFactGlobal"
                                                        [value]="mesFact.id">
                                                        {{mesFact.attributes.clave}}-{{mesFact.attributes.mes }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-xl-4">
                                            <mat-label>Año</mat-label>
                                            <mat-form-field appearance="fill">
                                                <input matInput placeholder="" formControlName="anioFactGlobal"
                                                    oninput="this.value = this.value.toUpperCase()" maxlength="4"
                                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </mat-card>
                                <!-- </div> -->
                            </div>
                        </form>
                    </div>
                    <!-- ********     Factura Global  ********  -->
                    <!-- *ngIf="!ocultarBotonActualizar" -->
                    <ng-container>
                        <div class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden"
                            style="background-color: #EDEDF3 !important;"
                            *ngIf="seleccionTipoFactura && !complementoPagoTemplate">
                            <div class="frm-producto">
                                <form [formGroup]="agregarProductoForm">
                                    <div class="row" *ngIf="!verForm">
                                        <div class="col-sm-8">
                                            <mat-form-field class="example-full-width" appearance="fill">
                                                <mat-label style="font-size: 16px !important;" class="mb-5">Seleccione producto o servicio</mat-label>
                                                <input matInput aria-label="State" matInput [formControl]="stateCtrl"
                                                    [matAutocomplete]="auto">
                                                <mat-autocomplete #auto="matAutocomplete"
                                                    (optionSelected)="selectProducto($event.option.value.id)"
                                                    [displayWith]="displayFn">
                                                    <mat-option *ngFor="let state of filteredStates | async"
                                                        [value]="state" style="height: 35px;">
                                                        <span>{{state.attributes.descripcion}}</span>
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-4">
                                            <button class="mt-6" (click)="openDialog();" mat-flat-button
                                                color="primary">Nuevo Producto</button>
                                        </div>
                                    </div>
                                    <div *ngIf="verForm">
                                        <div class="row">
                                            <div class="col-sm-9">
                                                <!-- Contenido para configurar producto o servicio -->
                                                <div class="row">
                                                    <div class="col-sm-12" [hidden]="descripcionRule?.hidden">
                                                        <mat-form-field [floatLabel]="'always'">
                                                            <mat-label style="font-size: 16px !important;">Producto
                                                                o Servicio</mat-label>
                                                            <input type="text" formControlName="descripcionProducto"
                                                                matInput style="font-size: 18px;" class="input-skinny"
                                                                [readonly]="descripcionRule?.disabled"
                                                                [maxlength]="descripcionRule?.maxLength"
                                                                [minlength]="descripcionRule?.minLength">
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12">


                                                    </div>

                                                    <div class="col-sm-2">
                                                        <mat-label>Clave Producto</mat-label><br>
                                                        <label style="font-size: 18px; text-align: right;">
                                                            {{curProducto?.attributes?.cat_clave_sat?.data?.attributes?.clave ?? ''}}
                                                        </label>
                                                    </div>

                                                    <div class="col-sm-2">
                                                        <mat-label>Clave Unidad</mat-label><br>
                                                        <label style="font-size: 18px; text-align: right;">
                                                            {{curProducto?.attributes?.cat_unidad?.data?.attributes?.clave ?? ''}}
                                                            <!-- -
                                                            {{curProducto?.attributes.cat_unidad.data.attributes.descripcion}} -->
                                                        </label>
                                                    </div>

                                                    <div class="col-sm-2" [hidden]="cantidadRule?.hidden">
                                                        <mat-form-field [floatLabel]="'always'">
                                                            <mat-label>Cantidad</mat-label>
                                                            <input type="number" formControlName="cantidad" matInput
                                                                style="font-size: 12px; text-align: right;"
                                                                (change)="changeCantidadForm($event)"
                                                                [readonly]="cantidadRule?.disabled">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-sm-2" [hidden]="valorUnitarioRule?.hidden">
                                                        <mat-form-field [floatLabel]="'always'">
                                                            <mat-label>Precio Unitario</mat-label><br>
                                                            <input type="number" formControlName="precioUnitario"
                                                                matInput style="font-size: 12px; text-align: right;"
                                                                (change)="changePrecioUnitarioForm($event)"
                                                                [readonly]="valorUnitarioRule?.disabled">
                                                        </mat-form-field>
                                                    </div>

                                                    <!-- <div class="col-sm-2" *ngIf="actulizarProducto">
                                                                    <mat-label>Unidad</mat-label><br>
                                                                    <label style="font-size: 18px; text-align: right;">
                                                                        {{codigoUnidadUpdate}}
                                                                    </label>
                                                                </div> -->

                                                    <div class="col-sm-2" [hidden]="descuentoRule?.fechaEmisionRule">
                                                        <mat-form-field [floatLabel]="'always'">
                                                            <mat-label>Forma de
                                                                descuento</mat-label>
                                                            <mat-select formControlName="formaDescuento"
                                                                placeholder='Seleccione'
                                                                (selectionChange)="formaDescuentoForm($event.value)">
                                                                <mat-option [value]="0">
                                                                    -
                                                                </mat-option>
                                                                <mat-option *ngFor="let descuento of ltsFormaDescuento"
                                                                    [value]="descuento.id">
                                                                    {{descuento.attributes.formaDescuento}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-sm-2" [hidden]="descuentoRule?.fechaEmisionRule">
                                                        <mat-form-field [floatLabel]="'always'">
                                                            <mat-label>Descuento</mat-label>
                                                            <input type="number" formControlName="descuento" matInput
                                                                style="font-size: 12px; text-align: right;"
                                                                (change)="changeDescuentoForm($event.target.value)">
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                                <ng-container *ngIf="adicionalesProducto">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <hr>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <form [formGroup]="cuentaPredialForm">
                                                                <mat-form-field [floatLabel]="'always'">
                                                                    <mat-label>Cuenta predial</mat-label>
                                                                    <mat-select formControlName="cuentaPredial"
                                                                        placeholder="Selecciona">
                                                                        <mat-option
                                                                            *ngFor="let predial of lstCuentaPredial"
                                                                            [value]="predial">
                                                                            {{ predial.attributes.cuentaPredial }}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>
                                                            </form>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <hr>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <div class="col-sm-3">
                                                <mat-label
                                                    style="text-align: right; font-size: 16px !important;">Totales</mat-label>
                                                <!-- Totales y sumatorias -->
                                                <table class="paddin-custom" style="width: 100%;">
                                                    <tr *ngIf="false">
                                                        <td style="width: 60%; text-align: right;">
                                                            <mat-label>Subtotal:</mat-label>
                                                        </td>
                                                        <td style="text-align: right;">
                                                            <label style="font-size: 18px;">
                                                                {{subtotal | number:'1.2-2'}}
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td style="width: 60%; text-align: right;">
                                                            <mat-label>SUBTOTAL:</mat-label>
                                                        </td>
                                                        <td style="text-align: right;">
                                                            <label style="font-size: 18px;">
                                                                {{ subtotalProducto | number:'1.2-2'}}
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td style="width: 60%; text-align: right;">
                                                            <mat-label>DESCUENTO:</mat-label>
                                                        </td>
                                                        <td style="text-align: right;">
                                                            <label style="font-size: 18px;">
                                                                {{ descuento | number:'1.2-2'}}
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colspan="2">
                                                            <div class="m-1 py-0.5 px-3 rounded-full text-sm font-medium text-gray-500 dark:text-gray-300 ng-star-inserted"
                                                                style="background-color: white;">
                                                                {{
                                                                curProducto?.attributes.cat_objeto_impuesto.data.attributes.valor
                                                                }}
                                                                - {{
                                                                curProducto?.attributes.cat_objeto_impuesto.data.attributes.nombre
                                                                }}
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <ng-container
                                                        *ngIf=" curProducto?.attributes.cat_objeto_impuesto.data.attributes.valor == '02' ">
                                                        <tr *ngIf="valueIvaProdSelect > 0">
                                                            <td style="width: 60%; text-align: right;">
                                                                <mat-label>{{ivaProdSelect}}:</mat-label>
                                                            </td>
                                                            <td style="text-align: right;">
                                                                <label style="font-size: 18px;">
                                                                    {{lastValueIvaProdSelect |
                                                                    number:'1.2-2'}}
                                                                </label>
                                                            </td>
                                                        </tr>

                                                        <tr *ngIf="valueIvaRetProdSelect > 0">
                                                            <td style="width: 60%; text-align: right;">
                                                                <mat-label>{{ivaRetProdSelect}}:</mat-label>
                                                            </td>
                                                            <td style="text-align: right;">
                                                                <label style="font-size: 18px;">
                                                                    {{lastValueIvaRetProdSelect |
                                                                    number:'1.2-2'}}
                                                                </label>
                                                            </td>
                                                        </tr>

                                                        <tr *ngIf="valueIEPSProdSelect > 0">
                                                            <td style="width: 60%; text-align: right;">
                                                                <mat-label>{{IEPSProdSelect}}:</mat-label>
                                                            </td>
                                                            <td style="text-align: right;">
                                                                <label style="font-size: 18px;">
                                                                    {{lastValueIEPSProdSelect |
                                                                    number:'1.2-2'}}
                                                                </label>
                                                            </td>
                                                        </tr>

                                                        <tr *ngIf="valueIsrProdSelect > 0">
                                                            <td style="width: 60%; text-align: right;">
                                                                <mat-label>{{isrProdSelect}}:</mat-label>
                                                            </td>
                                                            <td style="text-align: right;">
                                                                <label style="font-size: 18px;">
                                                                    {{lastValueIsrProdSelect |
                                                                    number:'1.2-2'}}
                                                                </label>
                                                            </td>
                                                        </tr>

                                                        <tr *ngIf="valueIEPSProdSelectCuota > 0">
                                                            <td style="width: 60%; text-align: right;">
                                                                <mat-label>{{IEPSProdSelectCuota}}:</mat-label>
                                                            </td>
                                                            <td style="text-align: right;">
                                                                <label style="font-size: 18px;">
                                                                    {{lastValueIEPSProdSelectCuota |
                                                                    number:'1.2-2'}}
                                                                </label>
                                                            </td>
                                                        </tr>


                                                    </ng-container>

                                                    <ng-container>
                                                        <tr *ngFor="let impuesto of impuestosLocales">
                                                            <td style="width: 60%; text-align: right;">
                                                                <mat-label>{{impuesto.nombre}}
                                                                    {{ impuesto.monto ? (impuesto.monto | currency :
                                                                    'MXN') :
                                                                    (impuesto.tasa ? (impuesto.tasa | percent : '.1-5')
                                                                    : '') }}:</mat-label>
                                                            </td>
                                                            <td style="text-align: right;">
                                                                <label style="font-size: 18px;">
                                                                    {{impuesto.importeImpuesto |
                                                                    number:'1.2-2'}}
                                                                </label>
                                                            </td>
                                                        </tr>
                                                    </ng-container>

                                                    <ng-container *ngIf="false">
                                                        <tr>
                                                            <td style="width: 60%; text-align: right;">
                                                                <mat-label>Total Impuestos
                                                                    Locales:</mat-label>
                                                            </td>
                                                            <td style="text-align: right;">
                                                                <label style="font-size: 18px;">
                                                                    {{ ImpuestosTotalesProducto |
                                                                    number:'1.2-2'}}
                                                                </label>
                                                            </td>
                                                        </tr>
                                                    </ng-container>

                                                    <ng-container *ngIf="false ">
                                                        <tr>
                                                            <td style="width: 60%; text-align: right;">
                                                                <mat-label>Total Impuestos:</mat-label>
                                                            </td>
                                                            <td style="text-align: right;">
                                                                <label style="font-size: 18px;">
                                                                    {{ totalImpuestos +
                                                                    ImpuestosTotalesProducto |
                                                                    number:'1.2-2'}}
                                                                </label>
                                                            </td>
                                                        </tr>
                                                    </ng-container>

                                                    <tr>
                                                        <td colspan="2">
                                                            &nbsp;
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td style="width: 60%; text-align: right;">
                                                            <mat-label>TOTAL:</mat-label>
                                                        </td>
                                                        <td style="text-align: right;">
                                                            <label style="font-size: 18px;">
                                                                {{total | number:'1.2-2'}}
                                                            </label>
                                                        </td>
                                                    </tr>

                                                </table>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-9">
                                                &nbsp;
                                                <button mat-raised-button class="fuse-mat-button-rounded"
                                                    [color]="'primary'" mat-flat-button (click)=" modificarProducto( curProducto )">
                                                    <span [style.color]="'#FFFFFF'">
                                                        Modificar el producto en catálogo
                                                    </span>
                                                </button>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="row">
                                                    <div class="col-sm-5">
                                                        <button mat-raised-button (click)="cacelarProducto()">
                                                            <span placeholder="  &#128269; Search">Cancelar</span>
                                                        </button>
                                                    </div>
                                                    <div class="col-sm-7">
                                                        <button *ngIf="!actulizarProducto" mat-raised-button
                                                            class="fuse-mat-button-rounded" [color]="'primary'"
                                                            mat-flat-button (click)="agregarProductosForGrid()">
                                                            <span [style.color]="'#FFFFFF'">
                                                                Agregar producto
                                                            </span>
                                                        </button>

                                                        <button *ngIf="actulizarProducto" mat-raised-button
                                                            class="fuse-mat-button-rounded" [color]="'primary'"
                                                            mat-flat-button (click)=" actualizarProductosForGrid()">
                                                            <span [style.color]="'#FFFFFF'">
                                                                Modificar producto
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="false">
                                            <div class="col-sm-8">
                                                <div class="row">
                                                    <div *ngIf="valueIvaProdSelect > 0" class="col-sm-4">
                                                        <mat-label>{{ivaProdSelect}}</mat-label><br>
                                                        <label style="font-size: 18px;">
                                                            {{lastValueIvaProdSelect | number:'1.2-2'}}
                                                        </label>
                                                    </div>
                                                    <div *ngIf="valueIvaRetProdSelect > 0" class="col-sm-4">
                                                        <mat-label>{{ivaRetProdSelect}}</mat-label><br>
                                                        <label style="font-size: 18px;">
                                                            {{lastValueIvaRetProdSelect | number:'1.2-2'}}
                                                        </label>
                                                    </div>
                                                    <div *ngIf="valueIsrProdSelect > 0" class="col-sm-4">
                                                        <mat-label>{{isrProdSelect}}</mat-label><br>
                                                        <label style="font-size: 18px;">
                                                            {{lastValueIsrProdSelect | number:'1.2-2'}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2" style="text-align: right;">
                                                <mat-label>Subtotal:</mat-label><br>
                                                <label style="font-size: 18px; text-align: right;">
                                                    {{subtotal | number:'1.2-2'}}
                                                </label>
                                            </div>
                                            <div class="col-sm-2" style="text-align: right;">
                                                <mat-label>Total:</mat-label><br>
                                                <label style="font-size: 18px; text-align: right;">
                                                    {{total | number:'1.2-2'}}
                                                </label>
                                            </div>
                                        </div>

                                        <div class="row" *ngIf="false">
                                            <div class="col-sm-12"
                                                style="justify-content: end; display: flex; margin-top: 30px;">

                                                <button mat-raised-button (click)="cacelarProducto()">
                                                    <span placeholder="  &#128269; Search">Cancelar</span>
                                                </button>

                                                <button *ngIf="!actulizarProducto" mat-raised-button
                                                    class="fuse-mat-button-rounded" [color]="'primary'" mat-flat-button
                                                    (click)=" agregarProductosForGrid()">
                                                    <span [style.color]="'#FFFFFF'">
                                                        Agregar producto
                                                    </span>
                                                </button>
                                                <button *ngIf="actulizarProducto" mat-raised-button
                                                    class="fuse-mat-button-rounded" [color]="'primary'" mat-flat-button
                                                    (click)="actualizarProductosForGrid()">
                                                    <span [style.color]="'#FFFFFF'">
                                                        Modificar producto
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class='col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2'>
                            </div>
                        </div>
                    </ng-container>


                    <div *ngIf="seleccionTipoFactura && !complementoPagoTemplate"
                        class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto overflow-hidden">
                        <div class="row">
                            <div class="col-sm-12">
                                <app-grid-component style="width: 100%;" *ngIf="verGrid"
                                    [datos]="objetoGridConfiguration?.Data" [columns]="objetoGridConfiguration.Columns"
                                    [exportExcel]="objetoGridConfiguration.ExportExcel"
                                    [columnHiding]="objetoGridConfiguration.ColumnHiding"
                                    [Checkbox]="objetoGridConfiguration.Checkbox"
                                    [Editing]="objetoGridConfiguration.Editing"
                                    [Columnchooser]="objetoGridConfiguration.Columnchooser"
                                    [searchPanel]="objetoGridConfiguration.SearchPanel"
                                    [scroll]="objetoGridConfiguration.Scroll" (messageEvent)="receiveMessage($event)"
                                    (datosevent)="datosMessage($event)" [toolbar]="objetoGridConfiguration.ToolBox"
                                    (onRowUpdated)="Actualizar($event)" (modificar)='modificar($event.modificar.key)'
                                    (eliminar)='eliminar($event.eliminar.key)'>
                                </app-grid-component>
                                <br><br><br><br><br>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="seleccionTipoFactura && complementoPagoTemplate"
                        class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto overflow-hidden">
                        <div class="row">
                            <div class="col-sm-12">
                                <mat-card>
                                    <app-complemento-pago [ltsMoneda]="ltsMoneda" [ltsMetodoPago]="ltsMetodoPago"
                                        (countPagosEventEmiter)="countPagosEventEmiter($event)"
                                        [ltsFormaPago]="ltsFormaPago" [ltsObjetoImpuesto]="ltsObjetoImpuesto"
                                        [banderaActualizarFactura]="banderaActualizarFactura"
                                        [allDataPago]="allDataPago"
                                        (countPagosValidaDatosEventEmiter)="countPagosValidaDatosEventEmiter($event)"></app-complemento-pago>
                                </mat-card>
                                <br><br><br><br><br>
                            </div>
                        </div>
                    </div>

                    <!-- Github issues summary -->
                    <div class="fixed col-sm-12 col-md-12 col-lg-12 col-xl-12 justify-content-end">
                        <div class="row">
                            <div class="col-sm-8">
                                <!--  *****    totales footer ************   -->
                                <table style="float: right;">
                                    <tr>
                                        <td style="padding:0 10px;">
                                            <small class="text-muted"><b>SUBTOTAL:</b></small><br>
                                            <b id="Subtotal">$ {{ (sumatoriaSinDescuento ) |
                                                number:'1.2-2'}}</b>
                                        </td>

                                        <ng-container *ngIf="sumatoriaDescuento != 0">
                                            <td style="padding:0 10px;">
                                                <small class="text-muted"><b>DESCUENTO:</b></small><br>
                                                <b id="Subtotal">$ {{ sumatoriaDescuento |
                                                    number:'1.2-2'}}</b>
                                            </td>
                                        </ng-container>

                                        <!-- <td style="padding:0 10px;">
                                            <b id="Subtotal">$ {{( sumatoriasTotales[1]?.sumatoria) |
                                                number:'1.2-2'}}</b>
                                        </td> -->

                                        <ng-container *ngIf="impuestosLocalesTotal.length != 0">
                                            <td style="padding:0 10px;" *ngFor="let item of impuestosLocalesTotal">
                                                <small class="text-muted"><b>{{ item.nombre }}:
                                                    </b></small><br>
                                                <b id="Subtotal">$ {{( item.importeImpuesto ) |
                                                    number:'1.2-2'}}</b>
                                            </td>
                                        </ng-container>
                                        <td *ngIf="sumatoriasTotales[1]?.sumatoria > 0" style="padding:0 10px;">
                                            <small class="text-muted"><b>IVA: </b></small><br>
                                            <b id="Subtotal">$ {{( sumatoriasTotales[1]?.sumatoria) |
                                                number:'1.2-2'}}</b>
                                        </td>
                                        <td *ngIf="sumatoriasTotales[2]?.sumatoria > 0" style="padding:0 10px;">
                                            <small class="text-muted"><b>IVARET: </b></small><br>
                                            <b id="Subtotal">$ {{( sumatoriasTotales[2]?.sumatoria) |
                                                number:'1.2-2'}}</b>
                                        </td>

                                        <td *ngIf="sumatoriasTotales[3]?.sumatoria > 0" style="padding:0 10px;">
                                            <small class="text-muted"><b>IEPS: </b></small><br>
                                            <b id="Subtotal">$ {{( sumatoriasTotales[3]?.sumatoria) |
                                                number:'1.2-2'}}</b>
                                        </td>

                                        <td *ngIf="sumatoriasTotales[4]?.sumatoria > 0" style="padding:0 10px;">
                                            <small class="text-muted"><b>ISR: </b></small><br>
                                            <b id="Subtotal">$ {{( sumatoriasTotales[4]?.sumatoria) |
                                                number:'1.2-2'}}</b>
                                        </td>

                                        <td style="padding:0 10px;">
                                            <small class="text-muted"><b>TOTAL:</b></small><br>
                                            <b id="Subtotal">$ {{sumatoriasTotales[5]?.sumatoria |
                                                number:'1.2-2'}}</b>
                                        </td>
                                    </tr>
                                </table>
                                <!--  *****    totales footer ************   -->
                                <div class="row" *ngIf="false">
                                    <div class="col-sm-2">
                                        <small class="text-muted">SUBTOTAL:</small><br>
                                        <b id="Subtotal">{{sumatoriasTotales[0]?.sumatoria |
                                            number:'1.2-2'}}</b>
                                    </div>
                                    <div class="col-sm-2" *ngIf="sumatoriasTotales[1]?.sumatoria > 0">
                                        <small class="text-muted">IVA: </small><br>
                                        <b id="Subtotal">{{( sumatoriasTotales[1]?.sumatoria) |
                                            number:'1.2-2'}}</b>
                                    </div>
                                    <div class="col-sm-2" *ngIf="sumatoriasTotales[2]?.sumatoria > 0">
                                        <small class="text-muted">IVARET: </small><br>
                                        <b id="Subtotal">{{( sumatoriasTotales[2]?.sumatoria) |
                                            number:'1.2-2'}}</b>
                                    </div>
                                    <div class="col-sm-2" *ngIf="sumatoriasTotales[3]?.sumatoria > 0">
                                        <small class="text-muted">IEPS: </small><br>
                                        <b id="Subtotal">{{( sumatoriasTotales[3]?.sumatoria) |
                                            number:'1.2-2'}}</b>
                                    </div>
                                    <div class="col-sm-2" *ngIf="sumatoriasTotales[4]?.sumatoria > 0">
                                        <small class="text-muted">ISR: </small><br>
                                        <b id="Subtotal">{{( sumatoriasTotales[4]?.sumatoria) |
                                            number:'1.2-2'}}</b>
                                    </div>
                                    <div class="col-sm-2">
                                        <small class="text-muted">TOTAL:
                                        </small><br>
                                        <b id="Subtotal">{{sumatoriasTotales[5]?.sumatoria |
                                            number:'1.2-2'}}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4" style="justify-content: end; display: flex;">
                                <!-- <button mat-raised-button>
                                                <span placeholder="  &#128269; Search"> Vista Previa</span>
                                            </button> -->
                                &nbsp;&nbsp;

                                <div *ngIf="!ocultarBotonActualizar">
                                    <div class="btn-group mr-4" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-light" #tooltip="matTooltip"
                                            matTooltip="Cerrar sin guardar" [matTooltipPosition]="'above'"
                                            (click)="cancelarFactura()">
                                            <mat-icon svgIcon="mat_outline:cancel"></mat-icon>
                                        </button>

                                        <button type="button" class="btn btn-light" *ngIf="!banderaActualizarFactura"
                                            #tooltip="matTooltip" matTooltip="Guardar EE" [matTooltipPosition]="'above'"
                                            (click)="Borrador()">
                                            <mat-icon svgIcon="mat_outline:save"></mat-icon>
                                        </button>

                                        <button type="button" class="btn btn-light" *ngIf="banderaActualizarFactura"
                                            #tooltip="matTooltip" matTooltip="Guardar ff" [matTooltipPosition]="'above'"
                                            (click)="actualizarFactura(1)">
                                            <mat-icon svgIcon="mat_outline:save"></mat-icon>
                                        </button>

                                        <button type="button" [disabled]="procesandoFactura" class="btn btn-light"
                                            (click)="vistaPrevia()">Vista previa</button>

                                        <!-- Boton de crear factura timbrada -->
                                        <button type="button" class="btn btn-primary"
                                            *ngIf="!banderaActualizarFactura && !complementoPagoTemplate"
                                            [disabled]="procesandoFactura">
                                            <span [style.color]="'#FFFFFF'" (click)="timbrar = true;Borrador()">&check;
                                                Crear Factura
                                            </span>
                                        </button>

                                        <button type="button" class="btn btn-primary" *ngIf="banderaActualizarFactura && !complementoPagoTemplate"
                                            [disabled]="procesandoFactura">
                                            <span [style.color]="'#FFFFFF'" (click)="timbrar = true;actualizarFactura(1)">&check;
                                                Actulizar Factura
                                            </span>
                                        </button>

                                        <!--Crea factura de complemento timbrada-->
                                        <button type="button" class="btn btn-primary"
                                            *ngIf="!banderaActualizarFactura && complementoPagoTemplate">
                                            <span [style.color]="'#FFFFFF'"
                                                (click)="timbrar = true;Borrador(true)">&check;
                                                Crear Complemento
                                            </span>
                                        </button>

                                        <button type="button" class="btn btn-primary"
                                        *ngIf="banderaActualizarFactura && complementoPagoTemplate">
                                        <!--(click)="actualizarFacturaTimbrar()">&check;-->
                                            <span [style.color]="'#FFFFFF'"
                                                (click)="timbrar = true;actualizarFactura(1)">&check;
                                                Actulizar Complemento
                                                </span>
                                                <!--(click)="">&check;-->
                                        </button>
                                    </div>
                                </div>

                                <!-- Botonera cuando duplicas factura y nota de credito -->
                                <div *ngIf="banderaActualizarFactura && banderaEstatusFactura === 2">
                                    <div class="btn-group mr-4" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-light" #tooltip="matTooltip"
                                            matTooltip="Cerrar sin guardar" [matTooltipPosition]="'above'"
                                            (click)="cancelarFactura()">
                                            <mat-icon svgIcon="mat_outline:cancel"></mat-icon>
                                        </button>

                                        <button type="button" class="btn btn-light" #tooltip="matTooltip"
                                            matTooltip="Guardar" [matTooltipPosition]="'above'" (click)="Borrador()">
                                            <mat-icon svgIcon="mat_outline:save"></mat-icon>
                                        </button>

                                        <button type="button" class="btn btn-light" (click)="vistaPrevia()">Vista
                                            previa</button>

                                        <button type="button" class="btn btn-primary">
                                            <!-- <span [style.color]="'#FFFFFF'" (click)="InsertarDatos()">&check; -->
                                            <span [style.color]="'#FFFFFF'" (click)="timbrar = true;Borrador()">&check;
                                                Duplicar Factura
                                            </span>
                                        </button>
                                        <!-- <button type="button" class="btn btn-primary"
                                            *ngIf="banderaActualizarFactura && complementoPagoTemplate">
                                            <span [style.color]="'#FFFFFF'" (click)="timbrar = true;Borrador(true)">&check;
                                                Crear Complementos
                                            </span>
                                        </button> -->
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" style="width: 100%;" *ngIf="!configured">
    <div class="col-sm-12">
        <div class="card p-4 m-5" *ngIf="!configured">
            <!-- Icon Section -->
            <div class="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white p-4 mb-4"
                style="width: 60px; height: 60px; margin: 0 auto;">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="icon-size-10" style="width: 40px; height: 40px;">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z">
                    </path>
                </svg>
            </div>

            <!-- Title Section -->
            <h5 class="card-title text-center">Emisor Requerido</h5>

            <!-- Description Section -->
            <p class="card-text text-secondary text-center">
                Aún no tienes un emisor configurado. Por favor, crea uno para habilitar el acceso a esta sección.
            </p>

            <!-- Button Section -->
            <div class="text-center mt-4">
                <a routerLink="/cuenta/nonecompany" class="btn btn-primary">Crear emisor</a>
            </div>
        </div>
    </div>
</div>